<template>
  <div class="hr-bill">
    <!-- tab切换 -->
    <div class="hr-bill-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!-- 列表搜索 -->
    <div class="search">
      <el-form
        ref="searchForm"
        :model="search"
      >
        <div class="search-row">
          <el-form-item label="日期：">
            <el-date-picker
              v-if="search.select === 1"
              v-model="search.date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="search.select === 2"
              v-model="search.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="btn-operation">
            <el-button icon="el-icon-search" class="btn-blue" @click="searchList">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <div class="hr-bill-container">
      <div class="table" v-if="tableData.length">
        <el-table 
          :data="tableData" 
          style="width: 100%" 
          :header-cell-class-name="headerCellClassName"
        >
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index+1"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                class="btn-text"
                type="text"
                @click="openDetails(scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div v-else class="nothing">
        <img class="nothing-img" src="~assets/images/nothing//hr-bill-nothing.png">
      </div>
    </div>

    
    <!-- 详情 -->
    <el-drawer
      class="bill-details-drawer"
      title="详情"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleCloseDrawer">
      <template slot="title">
        <span>详情</span>
      </template>
      <div class="drawer-content">
        <!-- 账单基本信息 -->
        <div class="base-info">
          <el-form
            ref="baseInfoForm"
            :model="baseInfoForm"
            label-width="100px"
          >
            <el-form-item label="账单周期" prop="billDate">
              <span class="base-info-content">{{ baseInfoForm.billDate }}</span>
            </el-form-item>
            <el-form-item label="劳务公司" prop="companyName">
              <span class="base-info-content">{{ baseInfoForm.companyName }}</span>
            </el-form-item>
            <el-form-item label="账单状态" prop="statusVal">
              <span class="base-info-status" :class="{'base-info-status-active':baseInfoForm.status == 2}">
                <span v-if="baseInfoForm.statusVal" :class="`circle${baseInfoForm.status}`" class="circle"></span>
                {{ baseInfoForm.statusVal }}
              </span>
            </el-form-item>
            <el-form-item label="总人数" prop="totalPeople">
              <span class="base-info-content base-info-content-hign">{{ baseInfoForm.totalPeople }}</span>
            </el-form-item>
            <el-form-item label="总工时" prop="totalTimes">
              <span class="base-info-content base-info-content-hign">{{ baseInfoForm.totalTimes }}</span>
            </el-form-item>
            <el-form-item label="总金额" prop="totalAmount">
              <span class="base-info-content base-info-content-hign">{{ baseInfoForm.totalAmount }}</span>
            </el-form-item>
          </el-form>
          
          <div class="drawer-download" v-if="billList.length" @click="exportExcel">
            <img src="~assets/images/home/upload-hign.png">
            导出
          </div>
        </div>

        <!-- 账单列表 -->
        <div class="adjustment-record">
          <p class="adjustment-record-title">账单列表</p>
          <div class="table records-table" v-if="billList.length">
            <el-table :data="billList" :header-cell-class-name="headerRecordsCellClassName">
              <el-table-column
                v-for="(item, index) in billTitleList"
                :key="index"
                :label="item.label"
                :prop="item.prop"
                :width="item.width"
                :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="nothing">
            <img class="nothing-img" src="~assets/images/nothing/nothing.png">
          </div>
        </div>
      </div>
      <div class="drawer-footer" v-if="baseInfoForm.status == 1">
        <el-button
          class="btn-blue"
          @click="batchVerification"
        >核实</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import hrBillMixins from '@/common/mixins/hr-bill.js'
export default {
  mixins: [hrBillMixins],

  data() {
    return {
      selectedTab: '月账单',
      search: {
        select: 2,
        date: "",
        month: "",
      },
    }
  },

  activated() {
    this.selectedTab = '月账单'
    this.search.select = 2
  },

  created() {
    this.initHrBillList()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/operator/hr-bill.scss';
</style>